import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-cp-range',
  templateUrl: './cp-range.component.html',
  styleUrls: [],
  standalone: false
})
export class CpRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
